module.exports = __webpack_public_path__ + "static/media/dsvbg.5112cc86.jpeg";